import { render, staticRenderFns } from "./Step1Component.vue?vue&type=template&id=06bd83e8&scoped=true&"
import script from "./Step1Component.vue?vue&type=script&lang=js&"
export * from "./Step1Component.vue?vue&type=script&lang=js&"
import style0 from "./Step1Component.vue?vue&type=style&index=0&id=06bd83e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bd83e8",
  null
  
)

export default component.exports